var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-space',_vm._l((_vm.filteredList),function(item){return _c('a',{key:item.id,attrs:{"href":item.completePath,"target":"_blank","download":""}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }